/* eslint-disable max-lines */
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const breakpoints = {
  xs: `(max-width:640px)`,
  sm: `(max-width:981px)`,
  md: `(max-width:1195px)`,
  lg: `(max-width:1680px)`,
  xl: `(max-width:2240px)`,
};

export const fontSizeVariants = {
  h1: `
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    @media ${breakpoints.sm} {
      font-size: 28px;
      line-height: 33.6px;
    }
  `,
  h2: `
    font-size: 28px;
    font-weight: 700;
    line-height: 33.6px;
    @media ${breakpoints.sm} {
      font-size: 22px;
      font-weight: 900;
      line-height: 26.4px;
    }
  `,
  h3: `
    font-size: 20px;
    font-weight: 900;
    line-height: 24px;
    @media ${breakpoints.sm} {
      font-size: 18px;
      line-height: 21.6px;
    }
  `,
  h4: `
    font-size: 16px;
    font-weight: 700;
    line-height: 21.6px;
    @media ${breakpoints.sm} {
      font-size: 14px;
      font-weight: 600;
      line-height: 16.8px;
    }
  `,
  body1: `
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  `,
  small: `
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
`,
};

export const GlobalStyle = createGlobalStyle`
  ${reset}

  *,
  *:before,
  *:after {
    box-sizing: border-box;
    -webkit-backface-visibility: hidden;
  }
  :root {
    --app-height: 100%;
    --track-item-max-height: 24px;
    --xxl-font-size: 72px;
    --xl-font-size: 56px;
    --lg-font-size: 32px;
    --md-font-size: 26px;
    --sm-font-size: 18px;
    --xs-font-size: 16px;

    --orange-primary: #f98723;
    --orange-primary-hover: #C2600B;
    --card-default: #1b1b1b;
    --card-active: #363636;
    --background-primary: #131313;
    --background-common: #1E1E1E;
    --player-bg-main: #1b1b1b;
    --white-secondary: #919191;
    --white-ghost: #FFFFFF80;
    --card-hover: #222222;
    --white-primary: #ffffff;
    --grey-primary: #515151;
    --error: #E83232;


    @media ${breakpoints.xl} {
      --xxl-font-size: 56px;
      --lg-font-size: 24px;
      --md-font-size: 20px;
      --sm-font-size: 14px;
    }

    @media ${breakpoints.lg} {
      --xxl-font-size: 40px;
      --xl-font-size: 40px;
      --lg-font-size: 20px;
      --md-font-size: 16px;
      --xs-font-size: 14px;
    }

    @media ${breakpoints.sm} {
      --track-item-max-height: 48px;
      --xl-font-size: 28px;
      --sm-font-size: 12px;
    }
  }
  html,
  body {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.9);
    background-color: rgba(37, 37, 37, 1);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: var(--app-height);
    line-height: 1.2;
    overflow-x: hidden;
    overflow-y: auto;
  }

  #root {
    height: 100%;
    display: grid;
    scrollbar-gutter: stable;

    overflow-y: scroll;
    overflow-x: inherit;

    @media ${breakpoints.sm} {
      overflow-y: auto;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 49px rgba(37,37,37,1) inset !important;
    -webkit-font-size: 20px !important;
    -webkit-text-fill-color: #fff;
    caret-color: white;
  }

  .blackPage-enter, .blackPage-exit-active {
    opacity: 0;
  }
  .blackPage-enter-active, .blackPage-exit {
    opacity: 1;
  }
  .blackPage-enter-active,
  .blackPage-exit-active {
    transition: opacity 100ms linear;
  }

  .blackPageForSide-enter {
    opacity: 0;
  }
  .blackPageForSide-enter-active {
    opacity: 1;
  }
  .blackPageForSide-exit {
    opacity: 1;
  }
  .blackPageForSide-exit-active {
    opacity: 0;
  }
  .blackPageForSide-enter-active,
  .blackPageForSide-exit-active {
    transition: opacity 100ms ease-out;
    overflow: hidden;
  }


.alert-enter {
  opacity: 0;
  transform: scale(0.9);
}
.alert-enter-active {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 300ms, transform 300ms;
}
.alert-exit {
  opacity: 1;
}
.alert-exit-active {
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 300ms, transform 300ms;
}


  .up-enter {
    opacity: 0;
    transform: translateY(-100%);
  }
  .up-enter-active {
    opacity: 1;
    transform: translateY(0);
  }
  .up-exit {
    opacity: 1;
    transform: translateY(0);
  }
  .up-exit-active {
    opacity: 0;
    transform: translateY(-100%);
  }
  .up-enter-active,
  .up-exit-active {
    transition: all 300ms;
  }

  .down-enter {
    opacity: 0;
    transform: translateY(100%);
  }
  .down-enter-active {
    opacity: 1;
    transform: translateY(0);
  }
  .down-exit {
    opacity: 1;
    transform: translateY(0);
  }
  .down-exit-active {
    opacity: 0;
    transform: translateY(100%);
  }
  .down-enter-active,
  .down-exit-active {
    transition: all 300ms;
  }

  .rightPoll-enter {
    opacity: 0;
    transform: translateX(100%);
  }
  .rightPoll-enter-active {
    opacity: 1;
    transform: translateX(0);
  }
  .rightPoll-exit {
    opacity: 1;
    transform: translateX(0);
  }
  .rightPoll-exit-active {
    opacity: 0;
    transform: translateX(-100%);
  }
  .rightPoll-enter-active,
  .rightPoll-exit-active {
    transition: all 800ms;
  }

  .leftPoll-enter {
    opacity: 0;
    transform: translateX(-100%);
  }
  .leftPoll-enter-active {
    opacity: 1;
    transform: translateX(0);
  }
  .leftPoll-exit {
    opacity: 1;
    transform: translateX(0);
  }
  .leftPoll-exit-active {
    opacity: 0;
    transform: translateX(100%);
  }
  .leftPoll-enter-active,
  .leftPoll-exit-active {
    transition: all 800ms;
  }

  .rightCounter-enter {
    opacity: 1;
    transform: translateX(100%);
  }
  .rightCounter-enter-active {
    opacity: 1;
    transform: translateX(0);
  }
  .rightCounter-exit {
    opacity: 1;
    transform: translateX(0);
  }
  .rightCounter-exit-active {
    opacity: 1;
    transform: translateX(100%);
  }
  .rightCounter-enter-active,
  .rightCounter-exit-active {
    transition: all 600ms;
  }

  .onRight-enter {
    transform: translateX(100%);
  }
  .onRight-enter-active {
    transform: translateX(0);
  }
  .onRight-exit {
    transform: translateX(0);
  }
  .onRight-exit-active {
    transform: translateX(100%);
  }
  .onRight-enter-active,
  .onRight-exit-active {
    overflow: hidden;
    transition: transform 200ms ease-in;
  }

  .onRightMenu-enter {
    transform: translateX(100%);
  }
  .onRightMenu-enter-active {
    transform: translateX(0);
  }
  .onRightMenu-exit {
    transform: translateX(0);
  }
  .onRightMenu-exit-active {
    transform: translateX(100%);
  }
  .onRightMenu-enter-active,
  .onRightMenu-exit-active {
    overflow: hidden;
    transition: transform 200ms ease-in;
  }

  .fromBottom-enter {
    transform: translateY(100%);
  }
  .fromBottom-enter-active {
    transform: translateY(0);
  }
  .fromBottom-exit {
    transform: translateY(0);
  }
  .fromBottom-exit-active {
    transform: translateY(100%);
  }
  .fromBottom-enter-active,
  .fromBottom-exit-active {
    overflow: hidden;
    transition: transform 200ms ease-in;
  }

  button {
    outline: none;
    border: none;
    cursor: pointer;
    background: none;
    color: #fff;
  }
`;
